<template>
  <div class="ui tab segment" data-tab="photo">
    <div class="ui top secondary menu">
      <a class="item" data-tab="photo/shop">店内</a>
      <a class="item" data-tab="photo/library">フォトライブラリー</a>
    </div>

    <div class="ui inner tab" data-tab="photo/shop">
      <table class="ui celled table">
        <tbody>
          <tr v-for="(form, i) in shopImageForms" :key="i">
            <td>
              <form class="ui form" :class="{'warning': form.hasErrors()}">
                <div class="fields">
                  <div class="required five wide field">
                    <label>画像</label>
                    <s3 v-model="form.model.image"></s3>
                    <validation-message :form="form" :field="'image'"></validation-message>
                  </div>
                  <div class="three wide field">
                    <label>サイト選択</label>
                    <div class="ui checkbox" style="display: block; margin-bottom: 5px;">
                      <input v-model="form.model.is_banquet" type="checkbox" value="true">
                      <label>宴会</label>
                    </div>
                    <div class="ui checkbox" style="display: block; margin-bottom: 5px;">
                      <input v-model="form.model.is_meeting" type="checkbox" value="true">
                      <label>会議室</label>
                    </div>
                    <div class="ui checkbox" style="display: block;">
                      <input v-model="form.model.is_lodge_meeting" type="checkbox" value="true">
                      <label>宿泊会議</label>
                    </div>
                  </div>
                  <div class="eight wide field">
                    <label>説明書き</label>
                    <div style="margin-bottom: 5px;">
                      <input type="text" v-model="form.model.banquet_description" placeholder="説明書き(宴会)">
                      <validation-message :form="form" :field="'banquet_description'"></validation-message>
                    </div>
                    <div style="margin-bottom: 5px;">
                      <input type="text" v-model="form.model.meeting_description" placeholder="説明書き(会議室)">
                      <validation-message :form="form" :field="'meeting_description'"></validation-message>
                    </div>
                    <div>
                      <input type="text" v-model="form.model.lodge_meeting_description" placeholder="説明書き(宿泊会議)">
                      <validation-message :form="form" :field="'lodge_meeting_description'"></validation-message>
                    </div>
                  </div>
                </div>
              </form>
            </td>
            <td class="actions">
              <button type="button" class="ui tiny positive button" @click="saveShopImage(form)">保存</button>
              <button type="button" class="ui tiny red button" @click="deleteShopImage(form, i)">削除</button>
            </td>
          </tr>
        </tbody>
        <tfoot class="full-width">
          <th colspan="2">
            <div class="ui center aligned">
              <i class="clickable plus green large icon" @click="newShopImage()"></i>
            </div>
          </th>
        </tfoot>
      </table>
    </div>

    <div class="ui inner tab" data-tab="photo/library">
      <div v-if="!reorderMode">
        <button class="ui mini default button" @click="reorderMode = true">並び順を変更する</button>
      </div>
      <div v-else>
        <button class="ui mini positive button" @click="reorderLibraryImage">並び順を保存する</button>
        <a class="clickable" @click="reload">キャンセル</a>
      </div>
      <table class="ui celled table">
        <tbody>
          <tr v-for="(form, i) in libraryImageForms" :key="i">
            <td v-if="reorderMode" style="width: 30px">
              <i @click="moveUp(libraryImageForms, i)" class="clickable arrow up icon"></i>
              <i @click="moveDown(libraryImageForms, i)" class="clickable arrow down icon"></i>
            </td>
            <td>
              <form class="ui form" :class="{'warning': form.hasErrors()}">
                <div class="fields">
                  <div class="required six wide field">
                    <label>画像</label>
                    <s3 v-model="form.model.image"></s3>
                    <validation-message :form="form" :field="'image'"></validation-message>
                  </div>
                  <div class="three wide field">
                    <label>サイト選択</label>
                    <div class="ui checkbox" style="display: block; margin-bottom: 5px;">
                      <input v-model="form.model.is_banquet" type="checkbox" value="true">
                      <label>宴会</label>
                    </div>
                    <div class="ui checkbox" style="display: block; margin-bottom: 5px;">
                      <input v-model="form.model.is_meeting" type="checkbox" value="true">
                      <label>会議室</label>
                    </div>
                    <div class="ui checkbox" style="display: block;">
                      <input v-model="form.model.is_lodge_meeting" type="checkbox" value="true">
                      <label>宿泊会議</label>
                    </div>
                  </div>
                  <div class="seven wide field">
                    <label>タグ</label>
                    <div v-for="tag in tags" :key="tag.value" class="ui checkbox">
                      <input v-model="form.model.tags" type="checkbox" :value="tag.value">
                      <label>{{ tag.label }}</label>
                    </div>
                  </div>
                </div>
              </form>
            </td>
            <td class="actions">
              <button type="button" class="ui tiny positive button" @click="saveLibraryImage(form)">保存</button>
              <button type="button" class="ui tiny red button" @click="deleteLibraryImage(form, i)">削除</button>
            </td>
          </tr>
        </tbody>
        <tfoot class="full-width">
          <th colspan="2">
            <div class="ui center aligned">
              <i class="clickable plus green large icon" @click="newLibraryImage()"></i>
            </div>
          </th>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
export default {
    data: function() {
        return {
            model: {},
            shopImageForms: [],
            libraryImageForms: [],
            reorderMode: false,
        }
    },
    mounted: function() {
        $('.ui.checkbox').checkbox();
    },
    computed: {
        tags() {
            return [
              {
                label: '宴会',
                value: 'food'
              },
              {
                label: '会場',
                value: 'venue'
              },
              {
                label: '備品',
                value: 'equipment'
              },
              {
                label: '什器',
                value: 'furniture'
              },
              {
                label: '宿泊会議',
                value: 'lodging'
              },
              {
                label: 'その他',
                value: 'others'
              }
            ];
        }
    },
    methods: {
        initialize: function(model) {
            this.model = model;
            _.forEach(this.model.shop_images, function(each) {
                this.shopImageForms.push(this.createForm(each));
            }.bind(this));
            _.forEach(this.model.photo_library, function(each) {
                this.libraryImageForms.push(this.createForm(each));
            }.bind(this));
        },
        newShopImage: function() {
            this.shopImageForms.push(this.createForm());
        },
        saveShopImage: function(form) {
            if (form.model.id) {
                form.put(form.model.edit_api_url, function(response) {
                    this.merge(form.model, response.data);
                    alert('保存しました');
                });
            } else {
                form.post(this.model.new_shop_image_api_url, function(response) {
                    this.merge(form.model, response.data);
                    alert('保存しました');
                });
            }
        },
        deleteShopImage: function(form, i) {
            if (!form.model.id) {
                this.shopImageForms.splice(i, 1);
                return;
            }
            if (!confirm('削除します。よろしいですか？')) {
                return;
            }
            form.delete(form.model.edit_api_url, function() {
                this.shopImageForms.splice(i, 1);
            }.bind(this));
        },
        newLibraryImage: function() {
            const form = this.createForm();
            this.$set(form.model, 'tags', []);
            this.libraryImageForms.push(form);
        },
        saveLibraryImage: function(form) {
            if (form.model.id) {
                form.put(form.model.edit_api_url, function(response) {
                    this.merge(form.model, response.data);
                    alert('保存しました');
                });
            } else {
                form.post(this.model.new_shop_photo_library_api_url, function(response) {
                    this.merge(form.model, response.data);
                    alert('保存しました');
                });
            }
        },
        moveUp: function(arr, i) {
            if (i === 0) {
                return;
            }
            var tmp = arr[i - 1];
            this.$set(arr, i-1, arr[i]);
            this.$set(arr, i, tmp);
        },
        moveDown: function(arr, i) {
            if (i === (arr.length - 1)) {
                return;
            }
            var tmp = arr[i + 1];
            this.$set(arr, i+1, arr[i]);
            this.$set(arr, i, tmp);
        },
        reorderLibraryImage: function() {
            this.createForm({
                ids: _.map(this.libraryImageForms, 'model.id')
            }).put(this.model.shop_photo_library_reorder_api_url, function() {
                this.reload();
            });
        },
        deleteLibraryImage: function(form, i) {
            if (!form.model.id) {
                this.libraryImageForms.splice(i, 1);
                return;
            }
            if (!confirm('削除します。よろしいですか？')) {
                return;
            }
            form.delete(form.model.edit_api_url, function() {
                this.libraryImageForms.splice(i, 1);
            }.bind(this));
        },
    }
};
</script>
